<template>
  <div>
    <Card :title="$t('message.transactions')" noborder>
      <template #header>
        <Modal
            :title="$t('message.withdraw')"
            :label="$t('message.withdraw')"
            labelClass="bg-black-100 dark:bg-slate-900 dark:text-slate-50 btn-sm"
            ref="modal2"
            :activeModal="show"
            @closeModal="closeModal"
            centered
        >
          <div class="space-y-4">
            <Alert
                v-if="isSubmittedWithdraw"
                type="success-outline"
                dismissible
                icon="akar-icons:double-check"
            >
              <span class="font-semibold">{{ $t('message.well_done') }}</span>
            </Alert>
            <Alert
                v-if="isSubmittedWithdraw === false"
                type="danger-outline"
                dismissible
                icon="heroicons-outline:exclamation"
            >
              <span class="font-semibold">{{ $t('message.failed') }}</span>
            </Alert>
            <Select :placeholder="$t('message.select_option')" label="Billing method"
                    :options="paymentMethods" v-model="paymentMethod" :error="paymentMethodError"/>
            <form ref="form">
              <div class="text-base text-slate-600 dark:text-slate-300 space-y-4">
                <Textinput
                    label="Amount"
                    type="number"
                    placeholder="Type your amount"
                    name="amount"
                    v-model="amount"
                    :error="amountError"
                    classInput="h-[48px]"
                />
              </div>
            </form>
          </div>
          <template v-slot:footer>
            <Button
                :text="$t('message.close')"
                btnClass="btn-outline-dark "
                @click="()=>{$refs.modal2.closeModal();}"
            />
            <button type="submit" @click="()=>{onSubmit(); isSubmittedWithdraw !== null ? removeAlert() : ''}"
                    class="btn btn-dark block text-center flex items-center justify-center gap-3">
              {{ $t('message.submit') }}
              <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
            </button>
          </template>
        </Modal>
      </template>
      <div class="-mx-6">
        <vue-good-table v-if="_transactions.length"
                        :columns="columns"
                        styleClass="vgt-table centered rtl:centered lesspadding2 table-head"
                        :rows="_transactions"
                        :pagination-options="{enabled: true, perPage: perpage}"
                        :sort-options="{enabled: false}">
          <template v-slot:table-row="props">
            <span v-if="props.column.field == 'id'">
              {{ "#" + props.row.id }}
            </span>
            <span v-if="props.column.field == 'lastUpdate'"
                  class="text-slate-500 dark:text-slate-300"
            >
              {{ convertTimestamp(props.row.lastUpdate) }}
            </span>
            <span v-if="props.column.field == 'state'" class="block w-full">
              <span
                  class="inline-block px-3 min-w-[90px] text-center mx-auto py-1 rounded-[999px] bg-opacity-25"
                  :class="`${
                  props.row.state === 'Waiting'
                    ? 'text-success-500 bg-success-500'
                    : ''
                }
            ${
              props.row.status === 'due'
                ? 'text-warning-500 bg-warning-500'
                : ''
            }
            ${
              props.row.status === 'cancled'
                ? 'text-danger-500 bg-danger-500'
                : ''
            }

             `"
              >
                {{ props.row.state }}
              </span>
            </span>
          </template>
          <template #pagination-bottom="props">
            <div class="py-4 px-3 flex justify-center">
              <Pagination
                  :total="_transactions.length"
                  :current="current"
                  :per-page="perpage"
                  :pageRange="pageRange"
                  @page-changed="current = $event"
                  :pageChanged="props.pageChanged"
                  :perPageChanged="props.perPageChanged"
              >
              </Pagination>
            </div>
          </template>
        </vue-good-table>
        <div v-else
             class="flex justify-center flex-wrap items-center flex-col text-center gap-10"
        >
          <img src="@/assets/images/all-img/no-data1.png" alt=""/>

          <p class="font-normal text-base text-slate-500 dark:text-slate-300">
            There are no transactions yet
          </p>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Card/index.vue";
import Icon from "@/components/Icon/index.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import Button from "@/components/Button/index.vue";
import Modal from "@/components/Modal/Modal.vue";
import {useI18n} from 'vue-i18n';
import {ref} from "vue";
import {usePaymentMethodsStore} from "@/stores/payment";
import Select from "@/components/Select/index.vue";
import Textinput from "@/components/Textinput/index.vue";
import * as yup from "yup";
import {useField, useForm} from "vee-validate";
import Alert from "@/components/Alert/index.vue";

export default {
  components: {
    Pagination,
    Icon,
    Tooltip,
    Card,
    Button,
    Modal,
    Select,
    Textinput,
    Alert
  },
  props: {
    _transactions: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      current: 1,
      perpage: 10,
      pageRange: 5,
      searchTerm: "",

      options: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "5",
          label: "5",
        },
      ],
    };
  },
  setup(props, {emit}) {
    const {t} = useI18n({useScope: 'global'})
    const columns = [
      {
        label: "Id",
        field: "id",
      },
      {
        label: "Last Update",
        field: "lastUpdate",
      },
      {
        label: "Amount",
        field: "amount",
      },
      {
        label: "Type",
        field: "type",
      },
      {
        label: "State",
        field: "state",
      },
    ];
    const modal2 = ref(null)
    const loading = ref(false)
    const show = ref(false);
    const paymentMethods = ref([])
    const paymentMethodsStore = usePaymentMethodsStore();
    const isSubmittedWithdraw = ref(null)

    const schema = yup.object({
      amount: yup.string().required("Amount is required").nullable(),
      paymentMethod: yup.string().required("Payment method is required").nullable(),
    })

    const formValues = {
      "amount": null,
      "paymentMethod": null
    }

    const {resetForm, handleSubmit} = useForm({
      validationSchema: schema,
      initialValues: formValues,
    });

    const {value: amount, errorMessage: amountError} = useField("amount");
    const {value: paymentMethod, errorMessage: paymentMethodError} = useField("paymentMethod");

    const onSubmit = handleSubmit(async (values) => {
      const withdraw = await paymentMethodsStore.withdraw({
        billingId: values.paymentMethod,
        amount: values.amount
      })
      if (withdraw) {
        isSubmittedWithdraw.value = true
        resetMyForm();
        emit('addedTransaction')
      } else {
        isSubmittedWithdraw.value = false
      }
    })

    function convertTimestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleDateString();
    }

    function closeModal() {
      //show.value = false;
      resetMyForm()
      removeAlert();
    }

    function resetMyForm() {
      resetForm();}

    async function getPaymentMethods() {
      //loading.value = true;
      await paymentMethodsStore.action_getPaymentMethods()
      //paymentMethods.value = paymentMethodsStore.getPaymentMethods;
      //console.log(paymentMethods.value)
      paymentMethods.value = paymentMethodsStore.getPaymentMethods.map(item => ({
        value: item.id,
        label: "(" + item.type + ") " + item.name,
      }));

      //loading.value = false;
    }

    getPaymentMethods();

    function removeAlert(){
      isSubmittedWithdraw.value = null
    }
    return {
      columns,
      convertTimestamp,
      closeModal,
      loading,
      modal2,
      show,
      paymentMethods,
      amount,
      amountError,
      paymentMethod,
      paymentMethodError,
      onSubmit,
      isSubmittedWithdraw,
      removeAlert,
      resetMyForm
    }
  }
};
</script>
<style lang="scss">
.action-btn {
  @apply h-6 w-6 flex flex-col items-center justify-center border border-slate-200 dark:border-slate-700 rounded;
}

.vgt-table thead th {
  @apply rtl:text-center;
}
</style>
